/**
 * @desc: 保理交易/当期交易
 * @created: 2020/6/9
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http'

export const getListData = params => {
  return request.get('/factoring/list/today/factoring', params)
}

// 获取流水号详情信息
export const getBillDetails = params => {
  return request.get('/factoring/details', params)
}

// 查询交易经纬度
export const getSelectCoordinatr = params => {
  return request.get('/factoring/selectCoordinate', params)
}
